import { useState } from 'react';
import {
	IplpTemplatesWhereInput,
	PaginationOrderHow,
	useLazyIplpTemplatesQuery,
} from '../../../graphql/graphql';

export function useIPLPTemplate() {
	const [getIPLPTemplatesQuery, { data, isLoading }] =
		useLazyIplpTemplatesQuery();
	const [page, setPage] = useState(1);

	const getIPLPTemplates = (filter: IplpTemplatesWhereInput) => {
		getIPLPTemplatesQuery({
			where: filter,
			pagination: {
				take: 20,
				skip: (page - 1) * 20,
				order: { key: 'term_items.name', how: PaginationOrderHow.Asc },
			},
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return {
		getIPLPTemplates,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
	};
}
